"use client";

import { motion } from "framer-motion";
import { TriangleAlert } from "lucide-react";
import { getViewModeChrome } from "./view-mode-chrome";

interface NotebookBusyNoticeProps {
  toolName: string;
  viewMode?: string;
}

export function NotebookBusyNotice({ toolName, viewMode}: NotebookBusyNoticeProps) {
  const chrome = getViewModeChrome(viewMode);
  const title =
    toolName === "replace_cell" || toolName === "edit_cell"
      ? "Notebook busy — update paused"
      : "Notebook busy — request paused";

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="w-full"
    >
      <div className={`rounded-md border ${chrome.card} overflow-hidden`}>
        <div className="px-3 py-2 flex items-center justify-between gap-3 min-w-0">
          <div className="flex items-center gap-2.5">
            <TriangleAlert className="w-4 h-4 text-yellow-500" strokeWidth={2} />

            <div className="flex flex-col">
              <span className={`text-[13px] font-semibold ${chrome.text} truncate`}>
                {title}
              </span>
              <span className={`text-[11px] ${chrome.subtext} truncate`}>
                This notebook is already handling another request. If you have multiple tabs or windows open, close the extras and try again.
              </span>
            </div>
          </div>

          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: "spring", stiffness: 300 }}
          >
            <TriangleAlert className="h-4 w-4 text-yellow-500" />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}
